import { lazy } from '@loadable/component';

const CheckoutForm = lazy(() =>
  import(
    /* webpackChunkName: "checkout_form" */
    './checkout_form'
  )
);

export default CheckoutForm;
